export const PRP_8542_Store_Manage_Config_Profile = 'PRP.8542.Store.Manage.Config.Profile';
export const PRP_3026_Store_Group = 'PRP.3026.Store.Group';
export const PRP_3160_Store_ConfigAssign_ProdLoc = 'PRP.3160.Store.ConfigAssign.ProdLoc';
export const PRP_2348_Enable_Supplier_Minimum = 'PRP.2348.Enable.Supplier.Minimum';
export const PRP_124330_Timezone = 'PRP.124330.Handle.UI.Timezone.Setting';
